import { useCallback, useState } from 'react';

import type { NoMedicationConfirmParams } from './types';

export default function useNoMedicationConfirm({
  hasSavedMedications,
  clearAll,
  setNoMedication,
}: NoMedicationConfirmParams) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleToggle = useCallback(
    (checked: boolean) => {
      if (!checked) {
        void setNoMedication(false);
        return;
      }
      setIsConfirmOpen(true);
    },
    [setNoMedication],
  );

  const handleConfirm = useCallback(async () => {
    // Hold the dialog open (buttons disabled via `confirmLoading`) until the bulk delete settles,
    // so a second save can't overlap it, and abort when it fails so the flag can't latch on.
    if (hasSavedMedications && !(await clearAll())) return;
    if (await setNoMedication(true)) setIsConfirmOpen(false);
  }, [clearAll, hasSavedMedications, setNoMedication]);

  const closeConfirm = useCallback(() => setIsConfirmOpen(false), []);

  return { isConfirmOpen, handleToggle, handleConfirm, closeConfirm };
}
